import React, { ComponentRef, useMemo, useRef } from 'react';

import { useAuth } from 'modules/authentication/presentation/contexts';
import {
  BlackNovemberCountdown,
  NavbarMenuIcon,
} from 'shared/presentation/components/atoms';
import {
  DrawerMenu,
  PackageSearchBox,
} from 'shared/presentation/components/molecules';
import { CONTACT_DEFAULT_MESSAGES, ICONS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import { selectRandomElementFromArray } from 'shared/presentation/helpers';
import { useTrackedWhatsappLink } from 'shared/presentation/hooks';

import * as S from './styles';

const MenuIcon = ICONS.MENU;

interface IMobileNavbarProps {
  variant?: S.TVariant;
}

const MobileNavbar: React.FC<IMobileNavbarProps> = ({
  variant = 'default',
}) => {
  const { t, language } = useLocale('shared');

  const drawerRef = useRef<ComponentRef<typeof DrawerMenu>>(null);
  const auth = useAuth();

  const message = useMemo(
    () => selectRandomElementFromArray(CONTACT_DEFAULT_MESSAGES[language]),
    [language],
  );

  const trackedLink = useTrackedWhatsappLink({
    event: 'clicou-botao-whats-header',
    message,
  });

  const customerName = useMemo(() => {
    const defaultName = t('Visitor');

    if (!auth.session) return defaultName;

    return auth.session.name;
  }, [t, auth.session]);

  return (
    <>
      <S.Container variant={variant}>
        <S.DrawerButton type="button" onClick={() => drawerRef.current?.open()}>
          <MenuIcon />
        </S.DrawerButton>

        <PackageSearchBox />

        <NavbarMenuIcon
          Icon={ICONS.WHATSAPP}
          type={'external'}
          title={'Whatsapp'}
          to={trackedLink.href}
          onClick={trackedLink.onClickLink}
        />
      </S.Container>

      <BlackNovemberCountdown />

      <DrawerMenu ref={drawerRef} customerName={customerName} />
    </>
  );
};

export default MobileNavbar;
